module.exports = "<gw-qnb-default-pa-base-coverages ng-if=\"$ctrl.lobCode() === 'personalAuto'\"\r\n                                  base-coverage-array=\"$ctrl.coverageData\">\r\n</gw-qnb-default-pa-base-coverages>\r\n\r\n<gw-qnb-default-ho-base-coverages ng-if=\"$ctrl.lobCode() === 'homeowners'\"\r\n                                  base-coverage-array=\"$ctrl.coverageData\">\r\n</gw-qnb-default-ho-base-coverages>\r\n<!-- Add other LOB coverage directives below here -->"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/integration/quoteandbind/directives/LobOfferingSelection/BaseCoverages/BaseCoverages.html
// module id = 621
// module chunks = 0